import { memo, useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from 'src/stores';
import { IBaseProps } from 'src/types/common.type';
import { Routes } from './route';

function RouteGuard({ children }: IBaseProps) {
  const { user } = useUser();
  const { pathname } = useLocation();

  const passed = useMemo<boolean>(() => {
    if (!user) return false;

    // if (user.type !== EUserType.ADMIN) {
    //   // @ts-ignore
    //   const route: IRoute = Routes[Object.keys(Routes).find((key: string) => Routes[key].path === pathname)];

    //   if (route.isAdmin) {
    //     return false;
    //   }
    // }

    return true;
  }, [user, pathname]);

  if (!user) return <Navigate to={Routes.LOGIN.path as string} />;

  if (!passed) return <Navigate to={Routes.PAGE403.path as string} />;

  return children;
}

export default memo(RouteGuard);
